var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M26.475 0.0004017L15 11.4504L3.525 0.000400697L6.5567e-07 3.5254L15 18.5254L30 3.5254L26.475 0.0004017Z","fill":"#E2231A"}));
}

DownArrow.defaultProps = {"width":"30","height":"19","viewBox":"0 0 30 19","fill":"none"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
